<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'Article',

    metaInfo: {
      title: 'News',
      meta: [
        { vmid: 'description', name: 'description', content: 'Read the latest news and insights from YOOXPLORE about UAV technology, anti-jamming systems, GNSS-denied flight, and drone industry trends.' },
        { vmid: 'keywords', name: 'keywords', content: 'YOOXPLORE, news, blog, UAV, drone, anti-jamming, GNSS-denied, drone industry' },
      ],
    },

    extends: View,

    mixins: [
      LoadSections([
        // 'hero-alt',
        'article',
        // 'social-media',
        // 'news',
        // 'newsletter-alt',
        // 'info',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'article',
      },
    },
  }
</script>
